
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'

import Clipboard from 'clipboard'
import $ from 'jquery';
import tabbar from '@/components/tabbar'
export default{
components: {
XHeader,
Group,
tabbar,
XButton,
Cell,
Toast,
CheckIcon
},
data(){
return{
list : [
],
ndata:2,
startX : 0 ,
endX : 0 ,
demo1: true,
loop:"",
clipboardText:"clipboardTextclipboardText",
clipboard:"",
ownerId:"",
showToast:false,
toastText:""
}
},
mounted(){
this.$vux.loading.show({
text: '加载中',
})
this.getOwnerAddress();

},
methods:{







backHome(){
this.$router.push({
path: '/home'
});
},
getOwnerAddress(){
let owner=JSON.parse(localStorage.getItem("ownerData"));
if(owner){
this.ownerId=owner.ownerId;
}
var that=this;
this.BM.JQajax({
url:this._Api.getAddress,
method:"GET",



success: function(data) {

that.list=data.data;
if(data.data){
that.ndata=1
}else{
that.ndata=0
}
that.$vux.loading.hide();
},
error:function(data){
that.$vux.loading.hide();

},
unAuth:function(){
that.$vux.loading.hide();
that.toastText="验证失败，请重新登录";
that.showToast = true;
setTimeout(function(){
localStorage.removeItem('loginData');
that.$router.push({
path: '/'
});
}.bind(this),1000)

}
})
},
copy(id){
let clipboard = new Clipboard("#copy"+id);
let that=this;
clipboard.on('success', function(e) {



that.$vux.toast.text('已成功复制到剪切板')
e.clearSelection();
});

clipboard.on('error', function(e) {


});
},
editItem(index,id){
this.$router.push({
name: 'update',
params: {
index:index,
id: id
}
})
},

touchStart(e){


this.startX = e.touches[0].clientX;
clearTimeout(this.Loop); 
this.Loop = setTimeout(function() {


let clipboard = new Clipboard(this.$refs.copyProShowUrl);

clipboard.on('success', function(e) {




e.clearSelection();
});

clipboard.on('error', function(e) {


});
}.bind(this), 1500);
},

touchEnd(e){

let parentElement = e.currentTarget.parentElement;

this.endX = e.changedTouches[0].clientX;










if( this.startX - this.endX <2  ){
this.restSlide();
parentElement.dataset.type = 0;
}
this.startX = 0;
this.endX = 0;
clearTimeout(this.Loop);





},
touchmove(e){

let parentElement = e.currentTarget.parentElement;

this.endX = e.changedTouches[0].clientX;


if( parentElement.dataset.type == 0 && this.startX - this.endX > 60  ){
this.restSlide();
parentElement.dataset.type = 1;
}


if( parentElement.dataset.type == 1 && this.startX - this.endX < -60 ){
this.restSlide();
parentElement.dataset.type = 0;
}
clearTimeout(this.Loop);
},

checkSlide(){
let listItems = document.querySelectorAll('.list-item');

for( let i = 0 ; i < listItems.length ; i++){
if( listItems[i].dataset.type == 1 ) {
return true;
}
}
return false;
},

restSlide(){
let listItems = document.querySelectorAll('.list-item');

for( let i = 0 ; i < listItems.length ; i++){
listItems[i].dataset.type = 0;
}
},

deleteItem(id,ind){
this.$vux.loading.show({
text: '正在删除',
})
let that=this;
let loginData=JSON.parse(localStorage.getItem("loginData"));
var token;
if(loginData){
token= loginData.token_type+" "+loginData.access_token;
}

$.ajax({
url : this._Api.deleteAdd,
type: "DELETE",
contentType:"application/json",
data:JSON.stringify({
"id":id
}),
beforeSend: function(xhr) {
xhr.setRequestHeader("Authorization", token);
},
success: function(res) {

if(res.code==200){
that.$vux.loading.hide();
that.toastText="删除成功";
that.showToast = true;
that.list.splice(ind,1);




}else{
that.toastText=res.msg
that.showToast = true;
}
},
error:function(res){


},
})

this.restSlide();
}
}
}



// WEBPACK FOOTER //
// ./src/pages/chargeAdd.vue